<template>
  <div class="pricing-desktop is-desktop">
    <PricingTableDesktopDetail
      :id="'toogle-plan-' + billingCycle"
      :scrollToPricing="scrollToPricing"
      :tooglePlanDropdown="tooglePlanDropdown"
      :features="featuresByPlan[billingCycle]"
      :billingCycle="billingCycle"
      :togglePlan="togglePlan"
      :permission="permission"
    />
  </div>
</template>

<script>
import featuresByPlan from './featuresByPlan'
import PricingTableDesktopDetail from './PricingTableDesktopDetail.vue'

export default {
  components: {
    PricingTableDesktopDetail,
  },
  props: {
    billingCycle: {
      type: String,
      default: 'annual',
    },
    // eslint-disable-next-line vue/require-default-prop
    togglePlan: {
      type: Function,
    },
    permission: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      featuresByPlan,
    }
  },
  methods: {
    scrollToPricing() {
      const element = document.getElementById('pricing-compare')
      const top = element.offsetTop - 150
      window.scrollTo(0, top)
    },
    tooglePlanDropdown() {
      const isVisible = 'is-visible'
      const planDropdown = document.getElementsByClassName('plans-row__dropdown')[0]
      if (planDropdown.classList.contains(isVisible)) {
        planDropdown.classList.remove(isVisible)
      } else {
        planDropdown.classList.add(isVisible)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/variable.scss";
  .pricing-desktop {
      margin-top: 3rem;
  }
  #toggle-plan-one-time.active,
  #toggle-plan-monthly.active,
  #toggle-plan-annual.active,
  #toggle-plan-educational.active {
    display: block !important;
  }
</style>
